<template>
    <el-card style="position: relative;margin-bottom:20px">
        <div slot="header">
            <span class="total_title">库存率</span>
            <div class="date_select">
                <span class="date_mode" :class="{'select':dateType==1}" @click="selectDateType(1)">本月</span>
                <span class="date_mode" :class="{'select':dateType==2}" @click="selectDateType(2)">本年</span>
                <span class="date_mode" :class="{'select':dateType==0}" @click="selectDateType(0)">自定义</span>
                <el-date-picker
                    v-show="dateType==0"
                    ref="dd"
                    size="mini"
                    v-model="dateRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 230px"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </div>
        </div>
        <div id="st3" style="height:200px;width:100%"></div>
    </el-card>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data(){
        return{
            dateRange:'',
            dateType:1,
        }
    },
    methods:{
        selectDateType:function(val){
            this.dateType = val;
            if(val==0){
                this.$refs.dd.focus();
            }
        },
        init:function(){
            this.$nextTick(()=>{
                let myChart = echarts.init(document.getElementById('st3'));
                let option = {
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "shadow"
                        }
                    },
                    grid:{
                        bottom:"10%",
                        height:"75%",
                    },
                    xAxis: {
                        type: 'category',
                        data: ['1号','2号','3号','4号','5号','6号','7号'],
                    },
                    yAxis: {
                        type: 'value',
                        splitNumber:5,
                        name: '单位:（千双）',
                    },
                    series: [
                        {
                            name:'库存',
                            data: [12,13.5,11,3,0,19,10],
                            type: 'line',
                            smooth: false,
                            color:'#167FFC',
                        }
                    ]
                };
                myChart.setOption(option);
            })
        },
    }
}
</script>